import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { ApiResponse } from "../../model";
import { ResponseHandler } from "./../../../utils/responce-handler";
import { HttpErrorHandler } from "../../../utils/http-error-handler";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class MonitoringService {
  url = environment.appMonitoringurl;

  constructor(private http: HttpClient) {}

  public getVisitorDetails(servicename: string) {
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }

  public getUserActivityDetails(servicename: string, selectedDate: string) {
    selectedDate = selectedDate.replace('-','/')
    selectedDate = selectedDate.replace('-','/')
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}/activityList?selectedDate=${selectedDate}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }

  public getUserActivityDetailsforUserId(
    servicename: string,
    selectedDate: string,
    userId: string
  ) {
    selectedDate = selectedDate.replace('-','/')
    selectedDate = selectedDate.replace('-','/')
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}/activityList/${userId}?selectedDate=${selectedDate}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }

  public getApiResponseGraph(
    apiName:string,
    servicename: string,
    selectedDate: string,
    userId: string
  ) {
    selectedDate = selectedDate.replace('-','/')
    selectedDate = selectedDate.replace('-','/')
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}/apiResponseGraph/${userId}?selectedDate=${selectedDate}&apiName=${apiName}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }

  public getAPIActivityDetails(
    servicename: string,
    selectedDate: string,
  ) {
    selectedDate = selectedDate.replace('-','/')
    selectedDate = selectedDate.replace('-','/')
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}/apiActivityList?selectedDate=${selectedDate}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }


  public getActivityDetailsforAPIName(
    servicename: string,
    selectedDate: string,
    apiName: string,
  ) {
    selectedDate = selectedDate.replace('-','/')
    selectedDate = selectedDate.replace('-','/')
    if(servicename == "paintshop") { servicename = "ps" }
    if(servicename == "controlroom") { servicename = "cr" }

    return this.http
      .get<ApiResponse<any>>(
        `${this.url}/dflAppMonitor/userMoniterDetails/service/${servicename}/activityList/detail?selectedDate=${selectedDate}&api=${apiName}`
      )
      .pipe(
        map((data) => {
          return ResponseHandler.processData<any>(data);
        }),
        catchError(HttpErrorHandler.handleError)
      );
  }
}
